import { render } from "./JcbIcon.vue?vue&type=template&id=62e377fa"
import script from "./JcbIcon.vue?vue&type=script&lang=js"
export * from "./JcbIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__